import { render, staticRenderFns } from "./VPmNoteForm.vue?vue&type=template&id=fcfcf5cc&"
import script from "./VPmNoteForm.vue?vue&type=script&lang=js&"
export * from "./VPmNoteForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports